export interface InquirySubmission {
  startingPoint: string;
  stage: string;
  situation: string;
  outcome: string;
  constraints: string;
  timeframe: string;
  collaboration: string;
  budgetReadiness: string;
  projectName: string;
  name: string;
  email: string;
  company: string;
  contactChannel: string;
}

interface InquiryApiResponse {
  ok?: boolean;
  message?: string;
}

type InquiryRequest = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;

export const INQUIRY_ENDPOINT = '/api/inquiry.php';

export async function sendInquiry(
  submission: InquirySubmission,
  startedAt: number,
  request: InquiryRequest = fetch,
  signal?: AbortSignal,
): Promise<void> {
  const response = await request(INQUIRY_ENDPOINT, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    signal,
    body: JSON.stringify({ ...submission, startedAt, website: '' }),
  });

  let result: InquiryApiResponse = {};
  try {
    result = (await response.json()) as InquiryApiResponse;
  } catch {
    // A non-JSON server response is handled by the status check below.
  }

  if (!response.ok || result.ok !== true) {
    throw new Error(result.message || 'The inquiry could not be sent. Please try again.');
  }
}
